import { graphql, withPrefix } from 'gatsby'
import { AnchorLink } from 'gatsby-plugin-anchor-links'
import React from 'react'
import { ContactPageTitle } from '@/components/contact/contact-page-title'
import { pagesPath } from '@/lib/pagesPath'
import * as Styles from './faq.module.scss'
import { Contact } from '@/components/general/contact'
import { Layout } from '@/components/general/layout'
import { Seo } from '@/components/general/seo'

// const CATEGORY = {
//   全般: 'generalFaq',
//   アカウントについて: 'accountFaq',
// }

const FaqPage = ({
  location,
  data: { allMicrocmsServiceFaq: allFaq },
  notLink = false,
}) => {
  const CATEGORY = Array.from(
    new Set(allFaq.nodes.map((node) => node.category[0]))
  ).reverse()

  return (
    <Layout location={location}>
      <Seo title="よくある質問" />
      <ContactPageTitle
        className={Styles.faq__pageTitle}
        decorationLogo
        en="FAQ"
        title="よくある質問"
      />

      <section>
        <div className={Styles.faq__content}>
          {CATEGORY.map((category) => (
            <div>
              <h3>{category}</h3>
              <ul>
                {allFaq.nodes
                  .filter((node) => category === node.category[0])
                  .map((node) => (
                    <li key={node.serviceFaqId}>
                      <details>
                        <summary>
                          {node.question}
                          <img src={withPrefix('/faq_icon_arrow.svg')} alt="" />
                        </summary>
                        <div
                          className={Styles.faq__details_content}
                          dangerouslySetInnerHTML={{ __html: node.answer }}
                        />
                      </details>
                    </li>
                  ))}
              </ul>
            </div>
          ))}
        </div>
        <div className={Styles.faq__btnset}>
          <p>その他のお問合せはこちらまで</p>
          {!notLink && (
            <div className={Styles.faq__btn}>
              <AnchorLink to={pagesPath.contact.$url()}>
                お問合せページへ
              </AnchorLink>
            </div>
          )}
        </div>
      </section>
      <Contact />
    </Layout>
  )
}

export const query = graphql`
  query {
    allMicrocmsServiceFaq {
      nodes {
        serviceFaqId
        question
        answer
        category
      }
    }
  }
`

export default FaqPage
